import React from 'react';
import PropTypes from 'prop-types';
import Modal, { ModalHeader, ModalContent } from '@tamagoshi/core/Modal';
import Text from '@tamagoshi/core/Text';
import { Round as CheckIcon } from '@tamagoshi/icons/Check';
import { getTranslations } from '@translations';

import styles from './styles/index.module.scss';

const NewsletterSuccess = ({ isVisible, onClose }) => {
  const translations = getTranslations();

  return (
    <Modal isVisible={isVisible} onClose={onClose}>
      <ModalHeader className={styles.header}>
        <CheckIcon className={styles.doneIcon} />
        <Text tag="span" type="h3" weight="bold" className={styles.title}>
          {translations('footer.contact.newsletter.modal.title')}
        </Text>
      </ModalHeader>
      <ModalContent className={styles.content}>
        <div className={styles.body}>
          {translations('footer.contact.newsletter.modal.subtitle')}
        </div>
      </ModalContent>
    </Modal>
  );
};

NewsletterSuccess.propTypes = {
  isVisible: PropTypes.bool.isRequired,
  onClose: PropTypes.func,
};

NewsletterSuccess.defaultProps = {
  onClose: () => {},
};

NewsletterSuccess.displayName = 'NewsletterSuccess';

export default NewsletterSuccess;
